module.exports = __webpack_public_path__ + "static/media/icon-world.a14d7453.svg";